import { render, staticRenderFns } from "./RegisterFooter.vue?vue&type=template&id=3392735c&scoped=true"
import script from "./RegisterFooter.vue?vue&type=script&lang=js"
export * from "./RegisterFooter.vue?vue&type=script&lang=js"
import style0 from "./RegisterFooter.vue?vue&type=style&index=0&id=3392735c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392735c",
  null
  
)

export default component.exports